/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=ed741b5a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=ed741b5a&lang=scss"

import exportComponent from "D:\\taiwan-bike-map\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__